import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowLeft } from 'lucide-react';
interface Slide13Props {
  onBack: () => void;
}
export function Slide13({
  onBack
}: Slide13Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 1,
    total: 1
  }} onBack={onBack} data-id="element-101">
      <div className="w-full max-w-4xl mx-auto space-y-8" data-id="element-102">
        <h1 className="text-3xl font-bold text-primary text-center mb-6" data-id="element-103">
          Individualised treatment approach
        </h1>
        <div className="bg-white rounded-2xl shadow-xl p-10 border border-teal-100/50" data-id="element-104">
          <p className="text-base text-gray-700 text-center leading-relaxed" data-id="element-105">
            Vabysmo<sup data-id="element-106">®</sup> is used within a Treat-and-Extend approach,
            allowing treatment intervals to be adapted based on disease
            activity, according to clinical assessment.<sup data-id="element-107">¹</sup>
          </p>
        </div>
        <div className="flex justify-center pt-4" data-id="element-108">
          <Button variant="primary" onClick={onBack} data-id="element-109">
            <ArrowLeft className="w-5 h-5" data-id="element-110" />
            Back to menu
          </Button>
        </div>
      </div>
    </SlideLayout>;
}